import script from "./Profile.vue?vue&type=script&setup=true&async=true&lang=js"
export * from "./Profile.vue?vue&type=script&setup=true&async=true&lang=js"

const __exports__ = script;

export default __exports__